module.exports = __webpack_public_path__ + "img/la-Experience.8e6e5233.png";